import React, { useEffect, useState } from "react"
import {Calendar,momentLocalizer,EventWrapperProps,CalendarProps,ToolbarProps} from "react-big-calendar"; 
import moment from "moment"
import { services } from "../../apis";
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Box,Typography } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import Loader from "../../components/Loader";
// import EventWrapper from "./EventWrapper";
import "../../styles/calender.css"
import "react-big-calendar/lib/css/react-big-calendar.css";
const localizer = momentLocalizer(moment)

const EventWrapper:React.FC<EventWrapperProps> = (props) => {
    const event:any = props.event;
    // console.log(event)

    //@ts-ignore
    const pastEvents = (new Date(event.start) < new Date()) ? 'pastevent' : 'future'
    //@ts-ignore
    const customClass = `calender-event rbc-event--${event.type} ${pastEvents}`;
    //@ts-ignore
    const customTagClass = `rbc-tag--${event.type}`;
    //@ts-ignore
    const hourStart = new Date(event.start).getHours();
    //@ts-ignore
    const hourStop = new Date(event.end).getHours();
    const gridRowStart = hourStart + 1;
    console.log(event.tags)
    return (
      <div
      title={moment(event.start).format("hh:mm A")}
        className={customClass}
        style={{ gridRow: `${gridRowStart} / span ${hourStop - hourStart}` }}
      >
        <div>
            <h6>{event.title}</h6>
            <p>{moment(event.start).format("hh:mm A")}</p>
            {event.tags && event.tags.length>0 && event.tags[0]!=null && <div className="event-tags" >
                {event.tags.map((tag:any)=>(
                    <div className={`event-single-tag ${customTagClass}`} >
                        {tag}
                    </div>
                ))}
            </div>}
            
        </div>
        <div>
            {
                event.type === 'session'?<img width={'30px'} src={require('../../assets/images/calender-event.svg')} />:event.type==='class'?
                <img width={'30px'} src={require('../../assets/images/calender-class.svg')} />:<img width={'30px'} src={require('../../assets/images/calendar-contest.svg')} />
            }
            
        </div>
        
      </div>
    );
  };

const ToobarWrapper:React.FC<ToolbarProps> = (props)=>{
    console.log(props)
    const defaultDate = props.date
    let newDateprev = new Date(
        defaultDate.getFullYear(),
        defaultDate.getMonth() - 1,
        1);
    let newDatenext = new Date(
        defaultDate.getFullYear(),
        defaultDate.getMonth() + 1,
        1);
    return (
        <div className="calender-toolbar" >
            {/* @ts-ignore */}
            <KeyboardArrowLeftIcon onClick={()=>props.onNavigate('prev', newDateprev)}/>
            <h3>{props.label}</h3>
            {/* @ts-ignore */}
            <KeyboardArrowRightIcon onClick={()=>props.onNavigate('next', newDatenext)}/>
        </div>
    )
}

const ShowAllEventsModal = ({open,handleClose,events,info}: {open:boolean,handleClose:any,events:any,info:any})=>{
    console.log(info.start)
    //@ts-ignore
    const pastEvents = (new Date(info.start) < new Date()) ? 'pastevent' : 'future'
    //@ts-ignore
    // const customClass = `calender-event rbc-event--${event.type} pastEvents`;
    //@ts-ignore
    const hourStart = new Date(info.start).getHours();
    //@ts-ignore
    const hourStop = new Date(info.end).getHours();
    const gridRowStart = hourStart + 1;
  
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <div className={'showeventsmodal'} >
                <h3>{new Date(info.start).toDateString()}</h3>
                {
                    events.length>0 ? events.map((event:any)=>(
                        <div
                            title={moment(event.start).format("hh:mm A")}
                                className={`calender-event rbc-event--${event.type} ${pastEvents}`}
                                style={{ gridRow: `${gridRowStart} / span ${hourStop - hourStart}` }}
                            >
                                <div style={{textAlign:'left'}}>
                                    <h5>{event.title}</h5>
                                    <p>{moment(event.start).format("MMM Do,hh:mm A")} - {moment(event.end).format("MMM Do,hh:mm A")}</p>
                                    {event.tags && event.tags.length>0 && event.tags[0]!=null &&<div className="event-tags" >
                                        { event.tags.map((tag:any)=>(
                                            <div className={`event-single-tag rbc-tag--${event.type}`} >
                                                {tag}
                                            </div>
                                        ))}
                                    </div>}
                                
                            </div>
                            <div>
                            {
                                event.type === 'session'?<img width={'30px'} src={require('../../assets/images/calender-event.svg')} />:event.type==='class'?
                                <img width={'30px'} src={require('../../assets/images/calender-class.svg')} />:<img width={'30px'} src={require('../../assets/images/calendar-contest.svg')} />
                            }
                            </div>
                        </div>
                    )) : <h4>No Events for this Day found.</h4>
                }
            
            </div>
        </Modal>
    )
}

const Calender2View = ()=>{
    const { user } = useSelector((state: any) => state.user);
    const [calenderEvents, setCalenderEvents] = useState([])

    const [selectedDayEvent, setSelectedDayEvents] = useState([])
    const [selectedDayInfo, setSelectedDayInfo] = useState({})
    const [open, setOpen]  = useState(false)

    const [defaultDate, setDefaultDate] = useState(new Date())

    

    useEffect(()=>{
        const getEvents =async ()=>{
            const userType = user.roles[0] === 'mentor' ? 'MENTOR' : 'USER';
            const res = await services.courseService.getCalenderEvents(user.id,userType)
            setCalenderEvents(res.events)
        }
        if(user) getEvents()

    },[user])

    const handleClose = ()=>{
        setOpen(false)
    }

    if(calenderEvents.length===0) return <Loader/>;
    return (
        <div className="calender">
            <ShowAllEventsModal open={open} handleClose={handleClose} info={selectedDayInfo} events={selectedDayEvent} />
            <Calendar
                components={{
                    eventWrapper: EventWrapper,
                    toolbar:ToobarWrapper
                    
                }}
                localizer={localizer}
                defaultDate={defaultDate}
                defaultView={'month'}
                // dayPropGetter={customDayPropGetter}
                events={calenderEvents}
                showAllEvents={true}
                popup={true}
                selectable={true}
                onSelectSlot={(info)=>{
                    const { start, end } = info;
                    const eventsForThisDay = calenderEvents.filter(
                       ( event:any) => ((new Date(event.start) >= new Date(start)) && (new Date(event.start) < new Date(end)))
                    )
                    setOpen(true)
                    setSelectedDayEvents(eventsForThisDay)
                    setSelectedDayInfo(info)
                }}
                // messages
            />
        </div>
    )
}

export default Calender2View